export const USER_FEATURE_ACCESS_CACHE_EXPIRY_TIME: number = 24 * 60 * 60; // 24 hours
export const LATEST_REPORT_DATES_CACHE_EXPIRY_TIME: number = 24 * 60 * 60; // 24 hours
export const BUILDINGS_LIST_CACHE_EXPIRY_TIME: number = 24 * 60 * 60; // 24 hours
export const BUILDINGS_CACHE_EXPIRY_TIME: number = 24 * 60 * 60; // 24 hours
export const ROOM_COUNT_CACHE_EXPIRY_TIME: number = 24 * 60 * 60; // 24 hours
export const DESKPOOL_COUNT_CACHE_EXPIRY_TIME: number = 24 * 60 * 60; // 24 hours
export const REPORT_CACHE_EXPIRY_TIME: number = 24 * 60 * 60; // 24 hours
export const CAMPUSES_CACHE_EXPIRY_TIME: number = 24 * 60 * 60; // 24 hours
export const FLOORS_CACHE_EXPIRY_TIME: number = 24 * 60 * 60; // 24 hours
